import React, { useEffect, useState } from "react";
import HelpSection from "../../../../components/dashboardcomponents/KnowledgeBase/KnowledgeBaseLangingPage/HelpSection";
import ArticleListKnowledgeBase from "../../../../components/dashboardcomponents/KnowledgeBase/KnowledgeBaseLangingPage/ArticleListKnowledgeBase";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { fetchArticlesExternal } from "../../../../store/features/getAllExternalArticles";
import { useDispatch, useSelector } from "react-redux";
import { saveSearchKeywordKbArticle } from "../../../../store/features/saveSearchKeywordKbArticle";
import { getTenantSlug, isKbSubdomain } from "../../../../utils";
import { getKbGroupId } from "../../../../utils/kbGroupId";

const KnowledgeBaseSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const groupId = getKbGroupId();

  const { articles: article = [], loading: articlesLoading } = useSelector(
    (state) => state.allExternalArticles
  );

  const initialQuery = searchParams.get("q")?.trim() || "";
  const [inputValue, setInputValue] = useState(initialQuery);
  const [committedQuery, setCommittedQuery] = useState(initialQuery);

  const businessName = getTenantSlug() || location?.state?.tenantSlug || sessionStorage.getItem('tenantSlug') || '';

  useEffect(() => {
    if (businessName) sessionStorage.setItem("tenantSlug", businessName);
  }, [businessName]);

  useEffect(() => {
    if (location?.state?.tenantSlug) {
      sessionStorage.setItem("tenantSlug", location.state.tenantSlug);
    }
  }, [location?.state?.tenantSlug]);

  // Sync input when URL changes (browser back/forward)
  useEffect(() => {
    const paramValue = searchParams.get("q")?.trim() || "";
    setInputValue(paramValue);
    setCommittedQuery(paramValue);
  }, [searchParams]);

  // Fetch all articles once when businessName is available
  useEffect(() => {
    if (!businessName || !groupId) return;
    dispatch(fetchArticlesExternal({ businessName, group_id: groupId }));
  }, [dispatch, businessName, groupId]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const trimmed = inputValue.trim();
      setCommittedQuery(trimmed);
      setSearchParams({ q: trimmed });
      dispatch(saveSearchKeywordKbArticle({ businessName, search: trimmed, group_id: groupId }));
    }
  };

  const handleSetSearchQuery = (value) => {
    setInputValue(value);
  };

  // Filter client-side
  const filteredArticles = React.useMemo(() => {
    if (!committedQuery) return [];
    const lowerQuery = committedQuery.toLowerCase();
    return article.filter((a) => a.title?.toLowerCase().includes(lowerQuery));
  }, [committedQuery, article]);

  const handleArticleClick = (slug) => {
    const tenant = businessName || sessionStorage.getItem("tenantSlug");
    if (isKbSubdomain()) {
      navigate(`/${slug}`);
    } else {
      sessionStorage.setItem("tenantSlug", tenant);
      navigate(`/kb/view/${slug}`, { state: { tenantSlug: tenant } });
    }
  };

  return (
    <>
      <HelpSection
        searchQuery={committedQuery}
        onSearchShow={false}
        title={`Here's what we found for "${committedQuery}"`}
        description={
          filteredArticles.length > 0
            ? `${filteredArticles.length} articles found `
            : "No articles were found. Feel free to try again or contact us."
        }
      />
      <ArticleListKnowledgeBase
        articles={filteredArticles}
        searchQuery={inputValue}
        setSearchQuery={handleSetSearchQuery}
        onKeyDown={handleKeyDown}
        minHeight="300px"
        onArticleClick={handleArticleClick}
        loading={articlesLoading}
      />
    </>
  );
};

export default KnowledgeBaseSearch;